import type { EditBookingController } from '@carlito/hotel-apis';
import { ControllerBodyParameters } from '@carlito/ddd';
import { bookitoRequest } from './api';

export type EditBookingParams = ControllerBodyParameters<EditBookingController>;

export async function editBooking(params: EditBookingParams) {
  return bookitoRequest<EditBookingController>('/booking', {
    body: JSON.stringify(params),
    method: 'PUT',
  });
}
